export const TERMS_AND_CONDITIONS_URL =
  'https://loadsmart.com/subscription-and-professional-services-agreement';

export const PRIVACY_POLICY_URL = 'https://loadsmart.com/privacy-policy';
